import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=ce20578a"
import script from "./Hub.vue?vue&type=script&lang=ts"
export * from "./Hub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports